module.exports = __webpack_public_path__ + "img/lastStepSelected.dda2df26.png";